import type { FC } from "react";
import {
  ErrorAlertCtxProvider as ErrorAlertCtxProviderBase,
  useErrorAlert,
} from "@commercekit/react";
import WvErrorAlert from "../components/molecules/WvErrorAlert";

export const ErrorAlertCtxProvider: FC<
  React.PropsWithChildren<{ error?: string; time?: number }>
> = (props, ...args) =>
  ErrorAlertCtxProviderBase(
    {
      ...props,
      ErrorAlert: ({ type, message }) => (
        <WvErrorAlert type={type} message={message} />
      ),
    },
    ...args
  );

export { useErrorAlert };
